import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';
import $ from 'jquery';
import PropTypes from 'prop-types';

import { RecommendationModal } from './modal';
import template from './template.pug';

class ModalContainer extends React.PureComponent {
  static propTypes = {
    el: PropTypes.string.isRequired,
    Form: PropTypes.shape({
      render: PropTypes.func.isRequired,
    }).isRequired,
    onCancel: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      isOpen: true,
    };
  }

  onAction = () => {
    this.setState({ isOpen: false });
  }

  render() {
    const { isOpen } = this.state;
    const { Form, onCancel } = this.props;

    return (
      <RecommendationModal
        isOpen={isOpen}
        onCancel={onCancel}
      >
        <Form
          extraAction={this.onAction}
          {..._.omit(this.props, 'Form', 'el')}
        />
      </RecommendationModal>
    );
  }
}

export function showRecommendationModal(options) {
  const container = document.querySelector('.recommendation-modal-container');
  if (container !== null) {
    ReactDOM.unmountComponentAtNode(container);
  } else {
    $(document.body).append(template());
  }
  ReactDOM.render(
    (
      <ModalContainer
        el=".recommendation-modal-container"
        {...options}
      />
    ), document.querySelector('.recommendation-modal-container')
  );
}
